'use strict'

var assign = Object.assign

module.exports = assign



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/constant/assign.js
// module id = 257
// module chunks = 0